export const ACTION_CHIP_TONE = {
    DEFAULT: 'default',
    MUTED: 'muted',
};

export const ACTION_CHIP_TONES = Object.values(ACTION_CHIP_TONE);

export const ACTION_CHIP_REMOVE_ICON = 'x-close';
